import React from 'react';
import './About.css'

const About = () => {
    return (
        // about page
        <div className="about">
            <h1 className="pt-5">About Us</h1>
            <p >At Abroad Higher Study Preparation, our aim is to offer you higher study idea that show you that we really care! Not only have we got the trendiest courrses, but we can also guarantee that they are of the finest quality.</p>
            <p className="pt-3 pb-5 ps-5 pe-5">With a motivated team, we strive to be the creative minds that bring a smile to your face. That’s why we’re always looking for innovative new ways to get the best to you.</p>
        </div>
    );
};

export default About;